"use client";

import { usePathname } from "next/navigation";
import { Footer } from "@/components/Footer/Footer";
import type { LinkProps } from "@/components/Footer/Footer";

interface ConditionalFooterProps {
  bgUrl: string;
  introTitle: string;
  introText: string;
  ctaTitle: string;
  ctaButton1Label: string;
  ctaButton1Href: string;
  ctaButton2Label: string;
  ctaButton2Href: string;
  navTechnology: LinkProps[];
  navCompany: LinkProps[];
  navPartnerships: LinkProps[];
  navResources: LinkProps[];
  navLegal: LinkProps[];
  navSocial: LinkProps[];
}

export function ConditionalFooter(props: ConditionalFooterProps) {
  const pathname = usePathname();

  // Don't render footer on ideas pages
  if (pathname.startsWith("/ideas")) {
    return null;
  }

  return <Footer {...props} />;
}
